import request from '@/utils/request'

// 获取审批列表
export function getExamineInfo(data) {
  return request({
    url: '/move/getExamineInfo',
    method: 'post',
    data
  })
}

// 获取审批详情
export function getApprovalDetail(id) {
  return request({
    url: `/approval/${id}`,
    method: 'get'
  })
}

// 提交审批
export function approveApproval(data) {
  return request({
    url: `/move/examine`,
    method: 'post',
    data
  })
}

// 提交审批
export function updateApprovalProcess(data) {
  return request({
    url: `/move/editExamineFlow`,
    method: 'post',
    data
  })
}

// 撤回审批
export function withdrawApproval(id) {
  return request({
    url: `/approval/${id}/withdraw`,
    method: 'post'
  })
}

// 创建审批
export function createApproval(data) {
  return request({
    url: '/approval',
    method: 'post',
    data
  })
} 

// 获取用户数据
export function getUserList(params) {
  return request({
    url: '/user/getUserList',
    method: 'get',
    params
  })
}


export function addApprovalProcess( data) {
  return request({
    url: `/move/addExamineFlow`,
    method: 'post',
    data
  })
}


export function getExamineTem(data) {
  return request({
    url: '/move/getExamineTem',
    method: 'post',
    data
  })
}

export function getOfferDetail(params) {
  return request({
    url: '/move/getOfferDetail',
    method: 'get',
    params
  })
}

export function getExamineFlowDetail(params) {
  return request({
    url: '/move/getExamineFlowDetail',
    method: 'get',
    params
  })
}

export function getBusActivitiesList(params) {
  return request({
    url: '/move/getBusActivitiesList',
    method: 'get',
    params
  })
}

export function toggleApprovalProcessStatus(){
	
}
export function addApproval(){
	
}
export function submitApproval(){
	
}